import { render, staticRenderFns } from "./AssListInfo.vue?vue&type=template&id=65652296&scoped=true"
import script from "./AssListInfo.vue?vue&type=script&lang=js"
export * from "./AssListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65652296",
  null
  
)

export default component.exports